<template>
  <div class="content">
    <div class="line_bac"></div>
    <div class="header">
      <i class="el-icon-date"></i>
      <span class="title">类别维护</span>
    </div>
    <div class="operate">
      <el-button class="add" @click="addBadge">新增</el-button>
      <el-button class="add" @click="editBadge">修改</el-button>
      <el-button type="danger" @click="deleteBadge">删除</el-button>
    </div>
    <div class="table_con">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="tableLoading"
        :height="windowHeight"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column prop="medalTypeName" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="weight" label="权重" align="center">
        </el-table-column>
        <el-table-column prop="cardTypeName" label="类型" align="center">
        </el-table-column>
        <el-table-column prop="monthMunber" label="每月数量" align="center">
        </el-table-column>
        <el-table-column prop="updateUserName" label="更新人" align="center">
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="openCustomConfig(scope.row)"
              v-if="scope.row.cardType == '1'"
              >自定义配置</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_con">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="`大类${title}`"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          :model="form"
          label-width="80px"
          class="demo-form-inline"
          :rules="rules"
          ref="ruleForm"
        >
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="名称" prop="medalTypeName">
                <el-input
                  v-model="form.medalTypeName"
                  placeholder="请输入名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="类型" prop="cardType">
                <el-select
                  v-model="form.cardType"
                  placeholder="请选择类型"
                  @change="handleCardType"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in optionsType"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="权重" prop="weight">
                <el-input
                  v-model="form.weight"
                  placeholder="请输入权重"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="isShowMonthMunber">
              <el-form-item label="每月数量" prop="monthMunber">
                <el-input
                  v-model="form.monthMunber"
                  placeholder="请输入每月数量"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button class="add" @click="confirmSubmit" :disabled="isBtnDisabled"
          >保存</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="deleteVisible" width="30%">
      <span>你确定要删除你选中的这条记录吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取 消</el-button>
        <el-button class="add" @click="confirmDetele" :disabled="isBtnDisabled"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 自定义配置弹框 -->
    <el-dialog
      title="自定义配置"
      :visible.sync="configDialogVisible"
      width="70%"
      :before-close="handleConfigClose"
    >
      <!-- 配置列表 -->
      <div class="config-section">
        <!-- 添加/编辑配置表单 -->
        <div class="config-form-section">
          <div class="section-title">
            {{ editingRowIndex >= 0 ? "编辑配置" : "添加配置" }}
          </div>
          <el-form
            :model="configForm"
            label-width="80px"
            class="config-form-inline"
            :rules="configRules"
            ref="configRuleForm"
          >
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="职级" prop="rtitle">
                  <el-select
                    v-model="configForm.rtitle"
                    placeholder="请选择职级"
                    clearable
                    filterable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in optionsRank"
                      :key="item.id"
                      :label="item.title"
                      :value="item.title"
                      :disabled="isRankExist(item.title)"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="卡数量" prop="sendCount">
                  <el-input
                    v-model="configForm.sendCount"
                    placeholder="请输入卡数量"
                    type="number"
                    @keydown.native="handleNumberKeyDown"
                    oninput="value=value.replace(/[^\d]/g,'')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态" prop="status">
                  <el-select
                    v-model="configForm.status"
                    placeholder="请选择状态"
                    style="width: 100%"
                  >
                    <el-option label="启用" :value="1"></el-option>
                    <el-option label="禁用" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-button type="success" @click="saveConfigRow">{{
                  editingRowIndex >= 0 ? "保存编辑" : "保存添加"
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="section-title">已配置列表</div>
        <div class="config-table" v-if="configTableData.length > 0">
          <el-table
            :data="configTableData"
            border
            style="width: 100%"
            :height="250"
            highlight-current-row
          >
            <el-table-column
              type="index"
              label="序号"
              width="60"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="rtitle" label="职级" align="center">
            </el-table-column>
            <el-table-column prop="sendCount" label="卡数量" align="center">
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status == 1">启用</el-tag>
                <el-tag v-else type="danger">禁用</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="editingRowIndex !== scope.$index"
                  type="primary"
                  size="mini"
                  @click="editConfig(scope.row, scope.$index)"
                  >修改</el-button
                >
                <el-button
                  v-if="editingRowIndex === scope.$index"
                  type="warning"
                  size="mini"
                  @click="cancelEdit"
                  >取消</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="empty-tip">暂无配置，请在下方添加</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleConfigClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/apis/medal";
export default {
  name: "badgeCategory",
  data() {
    return {
      pageData: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      tableData: [],
      multipleSelection: [],
      tableLoading: false,
      windowHeight: 350,
      dialogVisible: false,
      form: {
        medalTypeName: "",
        weight: null,
        cardType: "",
        monthMunber: "",
      },
      rules: {
        medalTypeName: [
          {
            required: true,
            trigger: "blur",
            validator: this.validatePass,
          },
        ],
        weight: [
          {
            required: true,
            trigger: "blur",
            validator: this.validateWeight,
          },
        ],
        cardType: [
          {
            required: true,
            trigger: "change",
            message: "请选择类型",
          },
        ],
        monthMunber: [
          {
            required: true,
            trigger: "blur",
            validator: this.validateMonthMunber,
          },
        ],
      },
      title: "新增",
      deleteVisible: false,
      itemId: "",
      optionsType: [],
      isShowMonthMunber: false,
      isBtnDisabled: false,
      // 职级列表
      optionsRank: [],
      // 自定义配置相关
      configDialogVisible: false,
      currentMedalTypeId: "",
      configTableData: [],
      configForm: {
        id: "",
        rtitle: "",
        sendCount: null,
        status: 1,
      },
      configRules: {
        rtitle: [{ required: true, message: "请选择职级", trigger: "change" }],
        sendCount: [
          {
            required: true,
            trigger: "blur",
            validator: this.validateMonthMunber,
          },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      isConfigBtnDisabled: false,
      editingRowIndex: -1, // 当前正在编辑的行索引，-1表示新增模式
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryData();
    this.queryType();
  },
  created() {
    this.getRankList();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // 判断职级是否已存在于配置列表中（存在则禁用）
    isRankExist(title) {
      // 如果是编辑当前行，不禁用自己
      if (this.editingRowIndex >= 0) {
        const currentRow = this.configTableData[this.editingRowIndex];
        if (currentRow.rtitle === title) {
          return false;
        }
      }
      // 其他已存在的职级全部禁用
      return this.configTableData.some((item) => item.rtitle === title);
    },
    handleResize() {
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 280;
      });
    },
    // 获取职级列表
    getRankList() {
      api
        .getPositionLevel({ type: "EmpRank" })
        .then((res) => {
          if (res.code == 200) {
            this.optionsRank = res.data || [];
          }
        })
        .catch((err) => {
          console.error("获取职级列表失败:", err);
        });
    },
    // 根据职级ID获取职级名称
    getRankTitle(rankId) {
      if (!rankId) return "";
      const rank = this.optionsRank.find((item) => item.id === rankId);
      return rank ? rank.title : rankId;
    },
    // 验证类别名称
    validatePass(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入类别名称"));
      } else {
        if (this.title == "新增") {
          const typeName = this.tableData.map((item) => item.medalTypeName);
          if (typeName.includes(value)) {
            callback(new Error("类别名称不能重复"));
          } else {
            callback();
          }
        } else {
          const typeName = this.tableData.filter(
            (item) => item.id != this.itemId
          );
          const typeNameList = typeName.map((item) => item.medalTypeName);

          if (typeNameList.includes(value)) {
            callback(new Error("类别名称不能重复"));
          } else {
            callback();
          }
        }
      }
    },
    // 验证权重
    validateWeight(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入权重"));
      } else {
        value = value.toString();
        var reg = /^((?!0)\d{1,9})$/;
        if (!value.match(reg)) {
          this.form.weight = null;
          callback(new Error("请输入正整数"));
        } else {
          callback();
        }
      }
    },
    // 验证每月
    validateMonthMunber(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入每月数量"));
      } else {
        value = value.toString();
        var reg = /^((?!0)\d{1,9})$/;
        if (!value.match(reg)) {
          this.form.monthMunber = null;
          callback(new Error("请输入正整数"));
        } else {
          callback();
        }
      }
    },
    // 选择table
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //分页
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    //页码
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.queryData();
    },
    //取消新增编辑弹框
    handleClose() {
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
      this.itemId = "";
    },
    // 显示 新增
    addBadge() {
      this.title = "新增";
      this.form = {
        medalTypeName: "",
        weight: null,
        cardType: "",
        monthMunber: "",
      };
      this.dialogVisible = true;
      this.isShowMonthMunber = false;
    },
    //显示 编辑
    editBadge() {
      if (this.multipleSelection.length == 1) {
        this.form.medalTypeName = this.multipleSelection[0].medalTypeName;
        this.form.weight = this.multipleSelection[0].weight;
        this.form.cardType = this.multipleSelection[0].cardType;
        this.form.monthMunber = this.multipleSelection[0].monthMunber;
        this.itemId = this.multipleSelection[0].id;
        this.title = "编辑";
        this.dialogVisible = true;
        this.isShowMonthMunber = this.form.cardType == 1;
      } else if (this.multipleSelection.length > 1) {
        return this.$message.warning("请选择一条内容进行编辑");
      } else {
        return this.$message.warning("请选择需要编辑的内容");
      }
    },
    // 确认新增 编辑
    confirmSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.title == "编辑") {
            this.form.id = this.multipleSelection[0].id;
          }
          this.isBtnDisabled = true;
          api
            .addOrUpdateMedalType({ ...this.form })
            .then((res) => {
              if (res.code == 200) {
                this.$message.success(this.title + "成功");
                this.itemId = "";
                this.dialogVisible = false;
                this.queryData();
              }
            })
            .catch(() => {
              this.isBtnDisabled = false;
            });
        }
      });
    },
    // 显示 删除弹框
    deleteBadge() {
      if (this.multipleSelection.length == 1) {
        if (this.multipleSelection[0].medals.length == 0) {
          this.deleteVisible = true;
        } else {
          return this.$message.warning("只能删除无所属徽章的徽章类别");
        }
      } else if (this.multipleSelection.length > 1) {
        return this.$message.warning("请选择一条内容进行删除");
      } else {
        return this.$message.warning("请选择需要删除的内容");
      }
    },
    //确认删除
    confirmDetele() {
      this.isBtnDisabled = true;
      api
        .deleteMedalType({ id: this.multipleSelection[0].id })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.deleteVisible = false;
            this.queryData();
          }
        })
        .catch(() => {
          this.isBtnDisabled = false;
        });
    },
    // 查询 列表
    queryData() {
      this.tableLoading = true;
      api
        .queryDataMedalType({ ...this.pageData })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.total;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 查询类型
    queryType() {
      api.queryByType({ type: "cardType" }).then((res) => {
        if (res.code == 200) {
          this.optionsType = res.data;
        }
      });
    },
    // 处理类型
    handleCardType(value) {
      this.isShowMonthMunber = value == 1;
    },

    // ====================== 【优化后】自定义配置 ======================
    // 打开自定义配置弹框
    openCustomConfig(row) {
      this.currentMedalTypeId = row.id;
      this.configDialogVisible = true;
      this.editingRowIndex = -1;
      this.resetConfigForm();
      this.queryConfigData();
    },
    // 查询配置列表
    queryConfigData() {
      api
        .queryMedalTypeDetail({
          page: 1,
          pageSize: 100,
          medalTypeId: this.currentMedalTypeId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.configTableData = res.data?.list || [];
          }
        });
    },
    // 重置表单
    resetConfigForm() {
      this.configForm = {
        id: "",
        rtitle: "",
        sendCount: null,
        status: 1,
      };
      this.$nextTick(() => {
        if (this.$refs.configRuleForm)
          this.$refs.configRuleForm.clearValidate();
      });
    },
    // 关闭
    handleConfigClose() {
      this.configDialogVisible = false;
      this.editingRowIndex = -1;
      this.resetConfigForm();
    },

    // 保存单行（新增/修改）—— 【修复：修改直接调用接口】
    saveConfigRow() {
      this.$refs.configRuleForm.validate((valid) => {
        if (!valid) return;

        // 重复校验
        const exists = this.configTableData.some(
          (item) =>
            item.rtitle == this.configForm.rtitle &&
            item.id !== this.configForm.id
        );
        if (exists) return this.$message.warning("该职级已配置");

        this.isConfigBtnDisabled = true;

        if (this.configForm.id) {
          // ====================== 【修改：直接调接口】
          api
            .editMedalTypeDetail({
              id: this.configForm.id,
              medalTypeId: this.currentMedalTypeId,
              rtitle: this.configForm.rtitle,
              sendCount: this.configForm.sendCount,
              status: this.configForm.status,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("修改成功");
                this.queryConfigData();
                this.editingRowIndex = -1;
                this.resetConfigForm();
              }
            })
            .finally(() => {
              this.isConfigBtnDisabled = false;
            });
        } else {
          // ====================== 【新增】
          api
            .addMedalTypeDetail({
              medalTypeId: this.currentMedalTypeId,
              rtitle: this.configForm.rtitle,
              sendCount: this.configForm.sendCount,
              status: this.configForm.status,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("添加成功");
                this.queryConfigData();
                this.resetConfigForm();
              }
            })
            .finally(() => {
              this.isConfigBtnDisabled = false;
            });
        }
      });
    },

    // 编辑配置
    editConfig(row, index) {
      this.editingRowIndex = index;
      this.configForm = {
        id: row.id,
        rtitle: row.rtitle,
        sendCount: row.sendCount,
        status: row.status,
      };
    },
    // 取消编辑
    cancelEdit() {
      this.editingRowIndex = -1;
      this.resetConfigForm();
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  background-color: #f2fcf9;
  height: 100%;
  .line_bac {
    width: 100%;
    height: 20px;
    // background-color: red;
  }
  .header {
    width: 100%;
    height: 90px;
    line-height: 90px;
    background-color: #efefef;
    border-bottom: 4px solid #d0d1d1;
    font-size: 29px;
    ::v-deep {
      .el-icon-date {
        color: #00ada7;
        margin: 0 10px 0 40px;
      }
    }
    .title {
      color: #00ada7;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }

  /* 自定义配置弹框样式 */
  .config-section {
    margin-bottom: 20px;
  }

  .config-form-section {
    padding-top: 15px;
    border-top: 1px dashed #d9d9d9;
  }

  .section-title {
    font-size: 26px;
    font-weight: 600;
    color: #333;
    margin-bottom: 12px;
    padding-left: 8px;
    border-left: 3px solid #23c0d8;
  }

  .config-table {
    margin-bottom: 0;
    ::v-deep {
      .el-table {
        font-size: 14px;
      }
      .el-table__header th {
        background-color: #fafafa;
        font-weight: 600;
      }
    }
  }

  .empty-tip {
    text-align: center;
    padding: 40px;
    color: #999;
    font-size: 14px;
    background-color: #fafafa;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
  }

  .config-form-inline {
    ::v-deep {
      .el-form-item {
        margin-bottom: 15px;
      }
      .el-input,
      .el-select {
        width: 100%;
      }
    }
  }

  .add-row-btn {
    margin-top: 25px;
    padding: 10px;
  }
}
</style>
